module.exports = __webpack_public_path__ + "img/27_38.90751f99.png";